export class CompiledChartsModel {
    studentStatusChart: any = {};
}